export const CommonKeys = {
  Log: 'log',
  User: 'user',
  Token: 'token',
  Alarm: 'alarm',
  Group: 'group',
  Sensor: 'sensor',
  Template: 'template',
  Firmware: 'firmware',
  Preference: 'preference',
} as const;

export const Message = {
  Fetching: 'درحال دریافت',
  FetchingInfo: 'درحال دریافت اطلاعات',
} as const;
